import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { list } from 'actions';
import { List } from 'components/Page';
import { CustomFilter } from 'components/Filtering';
import { Divider } from 'antd';

/**
 * @description Map data and server flight
 * @param {state} Object
 */
const mapStateToProps = (state, ownProps) => ({
  results: ownProps.format ? ownProps.format(state.api[ownProps.reducer.key].data.results) : state.api[ownProps.reducer.key].data.results,
  totalRecords: state.api[ownProps.reducer.key].data.count,
  inFlight: state.api[ownProps.reducer.key].inFlight
});

/**
 * @description Dispatch create, loadList, load, deleteItem
 * @param {dispatch} Object
 */
const mapDispatchToProps = (dispatch, ownProps) => ({
  loadList(page, pageSize, sorted, filters) {
    dispatch(list(ownProps.reducer.key, page, pageSize, sorted, filters));
  }
});

const Picker = ({
  canAdmin,
  classes,
  columns,
  customFilters,
  filtering,
  inFlight,
  loadList,
  onPinItem,
  onRowClick,
  pinnedItems,
  results,
  scroll,
  sorter,
  totalRecords,
  showInlinePin,
  isRecordPinnable,
}) => {
  // initialise table reference
  let table = null;
  /**
   * @description Call the table custom filter handlers
   * @param {data} Object
   * @trigger {handleCustomFilters}
   */
  const handleCustomFilters = (data) => {
    table.handleCustomFilters(data);
  };
  /**
   * @description Get the reference of the table
   * @param {data} Object
   */
  const getTableRef = (tableList) => {
    table = tableList;
  };

  return (
    <>
      {!isRecordPinnable() || pinnedItems.length === 0 ? '' : (
        <>
          <List
            canAdmin={canAdmin}
            columns={columns}
            className={classNames(classes, 'bhp-list-item-picker')}
            fitContents
            dataSource={pinnedItems}
            pinnedItems={pinnedItems}
            ref={getTableRef}
            inFlight={inFlight}
            onPinItem={onPinItem}
            onRowClick={onRowClick}
            scroll={scroll}
            selectedItemId={-1}
            commands={{
              showAdd: false,
              showDelete: false,
              showRefresh: false,
            }}
            sorter={sorter}
            title="Pinned Items"
            totalRecords={pinnedItems.length}
            showInlinePin={showInlinePin}
            isRecordPinnable={isRecordPinnable}
          />
          <Divider />
        </>
      )}
      <List
        canAdmin={canAdmin}
        columns={columns}
        className={classNames(classes, 'bhp-list-item-picker bhp-container')}
        customFilters={customFilters}
        dataSource={results}
        pinnedItems={pinnedItems}
        ref={getTableRef}
        inFlight={inFlight}
        onLoadList={loadList}
        onPinItem={onPinItem}
        onRowClick={onRowClick}
        scroll={scroll}
        selectedItemId={-1}
        commands={{
          showAdd: false,
          showDelete: false,
          showRefresh: true
        }}
        sorter={sorter}
        title={isRecordPinnable() && pinnedItems.length > 0 ? 'All items' : ''}
        toolbar={(
          <CustomFilter
            classes="bhp-filterbar-compact"
            reducerKey={filtering.key}
            placeholder={filtering.placeholder}
            maxTagCount={1}
            themeName={filtering.theme}
            onUpdateCustomFilters={handleCustomFilters}
            showSearch={false}
            showClearButton={false}
            showToggle={false}
            title={null}
          />
        )}
        totalRecords={totalRecords}
        showInlinePin={showInlinePin}
        isRecordPinnable={isRecordPinnable}
      />
    </>
  );
};

Picker.propTypes = {
  canAdmin: PropTypes.bool,
  classes: PropTypes.string,
  columns: PropTypes.array.isRequired,
  customFilters: PropTypes.object,
  filtering: PropTypes.object,
  inFlight: PropTypes.bool,
  loadList: PropTypes.func,
  onPinItem: PropTypes.func,
  onRowClick: PropTypes.func,
  pinnedItems: PropTypes.array,
  results: PropTypes.array,
  scroll: PropTypes.object,
  sorter: PropTypes.object,
  totalRecords: PropTypes.number,
  showInlinePin: PropTypes.bool,
  isRecordPinnable: PropTypes.func,
};

Picker.defaultProps = {
  canAdmin: true,
  classes: '',
  customFilters: {},
  filtering: {},
  inFlight: false,
  loadList() {
  },
  onPinItem() {
  },
  onRowClick() {
  },
  pinnedItems: [],
  results: [],
  scroll: {},
  sorter: {},
  totalRecords: 0,
  showInlinePin: false,
  isRecordPinnable: () => false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Picker);
